module.exports = __webpack_public_path__ + "static/media/when-and-why-workl.d5412ba4.svg";